export const QUESTION_TYPE = {
  INFO: 'INFO',
  TEXTFIELD: 'TEXTFIELD',
  CLOSED: 'CLOSED',
  SLIDER10: 'SLIDER10',
  SLIDER11: 'SLIDER11',
  MULTI: 'MULTI',
  FINISHED: 'FINISHED',
}
